import { useEffect, useState } from 'react';

import { getReceiptLinks } from '../../../budget/api/budget';

/**
 * Card charges the given receipts are bound to, keyed by receipt id. Empty
 * when the budget module is off or the lookup fails: the receipt list works
 * without it.
 */
export default function useReceiptCardLinks(receipts) {
  const [links, setLinks] = useState({});

  useEffect(() => {
    let cancelled = false;
    const ids = receipts.map((r) => r.id);
    if (ids.length === 0) {
      setLinks({});
      return undefined;
    }
    getReceiptLinks(ids)
      .then((rows) => {
        if (cancelled) return;
        const byReceipt = {};
        for (const row of rows || []) byReceipt[row.receiptId] = row;
        setLinks(byReceipt);
      })
      .catch((err) => console.warn('Could not load receipt card links', err));
    return () => {
      cancelled = true;
    };
  }, [receipts]);

  return links;
}
